import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { observer } from "mobx-react"
import {
  useConfigurationStore,
  useMobileDevicesStore,
  useHearingEvaluationStore,
  useUiStore,
  useLogsStore,
} from "hooks/stores"
import { format } from "date-fns"
import { Menu, MenuItem } from "@material-ui/core"
import { handleSelectInputsOld } from "../programs_helpers"
import { DEFAULT_CONFIG_FACTORY } from "stores/configuration_store/configuration_mock_objects"
import { mapKeysToCamelCase } from "utils/helpers"
import { handleSelectInputs } from "../programs_helpers"
import { ManualIcon } from "images/svg"

const ConfigurationHistoriesWrapper = styled.div`
  max-height: 150px;
  border-top: 1px solid rgba(55, 55, 55, 0.17);
  overflow: auto;
`

const HistoryConfigItem = styled.div`
  border-bottom: 1px solid rgba(55, 55, 55, 0.17);
  background-color: ${({ active }) => (active ? "#F0F0F0" : "white")};
  font-weight: ${({ active }) => (active ? "bold" : "normal")};
  padding: 16px;
  position: relative;
  display: flex;

  &:hover {
    cursor: pointer;
  }
`

const DateWrapper = styled.div`
  display: inline-block;
  flex: 1;
`

const ManualWrapper = styled.div`
  display: inline-block;
  margin-left: 20px;
  position: relative;
  top: 3px;
`

const LabelWrapper = styled.div`
  display: inline-block;
  flex: 0.3;
  padding-right: 10px;
`

const ControlButtons = styled.div`
  display: inline-block;
  justify-content: flex-end;
  flex: 0.1;
  position: relative;
  right: 0;
  bottom: 10px;
  height: 12px;
`

const StatusWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  padding-left: 10px;
`

const EmptyCircle = styled.div`
  height: 24px;
  width: 24px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  border: 2px solid gray;
`

const BigCircle = styled.div`
  height: 24px;
  width: 24px;
  background-color: #cf4520;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const SmallCircle = styled.div`
  height: 18px;
  width: 18px;
  background-color: #cf4520;
  border-radius: 50%;
  border: 2px solid white;
`

const CheckCircle = styled.div`
  height: 24px;
  width: 24px;
  background-color: #32813b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const CheckIcon = styled.svg`
  width: 14px;
  height: 14px;
  stroke: white;
  stroke-width: 3;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
`

const HearingEvaluationHistory = () => {
  const {
    setTempHearingAssessmentLeftBisgaardIndex,
    setTempHearingAssessmentRightBisgaardIndex,
    hearingEvaluationHistoryList,
    setPreviewHearingAssessmentLeftBisgaardIndex,
    setPreviewHearingAssessmentRightBisgaardIndex,
    setPreviewIndex,
    previewIndex,
    activeHearingAssessmentIndex,
    setEnabledConfigurationOfIndex,
    setIsNewSoundMatch,
    isNewSoundMatch,
    removeHearingEvaluation,
    setNewHearingAssessment,
    isShowingRevert,
  } = useHearingEvaluationStore()

  const {
    setApplyForReset,
    applyForReset,
    selectInputs,
    handleApplySoundMatchFromHistory,
  } = useConfigurationStore()

  const { isNewConfig } = useMobileDevicesStore()

  const [anchorEl, setAnchorEl] = useState(null)
  const [tempIndex, setTempIndex] = useState(null)

  useEffect(() => {
    setTempIndex(activeHearingAssessmentIndex)
  }, [activeHearingAssessmentIndex])

  useEffect(() => {
    if (tempIndex !== null) {
      handleApplySoundMatchFromHistory()
    }
  }, [tempIndex])

  const handleClose = () => {
    setAnchorEl(null)
  }

  const applyConfiguration = (index) => {
    let tempDeviceConfiguration = mapKeysToCamelCase(
      DEFAULT_CONFIG_FACTORY().device_configuration
    )

    if (index === "reset") {
      if (isNewSoundMatch) {
        removeHearingEvaluation("manual")
        setIsNewSoundMatch(false)
      }
      setPreviewHearingAssessmentLeftBisgaardIndex(null)
      setPreviewHearingAssessmentRightBisgaardIndex(null)
      setTempHearingAssessmentLeftBisgaardIndex(null)
      setTempHearingAssessmentRightBisgaardIndex(null)
      setPreviewIndex(null)
      setTempIndex(null)
      setApplyForReset(true)
      isNewConfig
        ? handleSelectInputs(selectInputs, tempDeviceConfiguration, true)
        : handleSelectInputsOld(selectInputs, tempDeviceConfiguration, true)
      handleClose()
    } else {
      setApplyForReset(false)
      setEnabledConfigurationOfIndex(index)
      setTempIndex(index)
      handleApplySoundMatchFromHistory()
      handleClose()
    }
  }

  const { showHearingAssessmentModal } = useUiStore()
  const { newHearingAssessment } = useHearingEvaluationStore()

  const applyHEPreview = (index) => {
    setPreviewIndex(index)
    if (showHearingAssessmentModal) {
      const ha = hearingEvaluationHistoryList[index]
      const newHA = { ...newHearingAssessment }
      newHA.leftBisgaardIndex = ha.leftBisgaardIndex
      newHA.rightBisgaardIndex = ha.rightBisgaardIndex
      newHA.left500HzThreshold = ha.left500HzThreshold
      newHA.left1000HzThreshold = ha.left1000HzThreshold
      newHA.left2000HzThreshold = ha.left2000HzThreshold
      newHA.left3000HzThreshold = ha.left3000HzThreshold
      newHA.left4000HzThreshold = ha.left4000HzThreshold
      newHA.right500HzThreshold = ha.right500HzThreshold
      newHA.right1000HzThreshold = ha.right1000HzThreshold
      newHA.right2000HzThreshold = ha.right2000HzThreshold
      newHA.right3000HzThreshold = ha.right3000HzThreshold
      newHA.right4000HzThreshold = ha.right4000HzThreshold

      setNewHearingAssessment(newHA)
    } else {
      setPreviewHearingAssessmentLeftBisgaardIndex(
        hearingEvaluationHistoryList[index].leftBisgaardIndex
      )
      setPreviewHearingAssessmentRightBisgaardIndex(
        hearingEvaluationHistoryList[index].rightBisgaardIndex
      )
    }
  }

  const { lastLogWithStatus } = useLogsStore()

  const showEnabled = (active) => {
    if (showHearingAssessmentModal) return false
    return !isShowingRevert && !showHearingAssessmentModal && active
  }

  const showPending = (hearingEvaluationId) => {
    if (showHearingAssessmentModal) return false
    return (
      lastLogWithStatus?.payload?.hearingAssessment?.id == hearingEvaluationId
    )
  }

  const showEmptyCircle = (hearingEvaluation, index) => {
    if (showHearingAssessmentModal) return false
    if (showEnabled(hearingEvaluation.active)) return false
    if (
      lastLogWithStatus?.payload?.hearingAssessment?.id == hearingEvaluation.id
    )
      return false
    if (tempIndex == index) return false
    return true
  }

  const showSelected = (hearingEvaluation, index) => {
    if (showHearingAssessmentModal) return false
    return (
      !showPending(hearingEvaluation.id) &&
      !hearingEvaluation.active &&
      tempIndex == index
    )
  }

  const resetTempIndex = () => {
    setTempIndex(null)
    setPreviewIndex(null)
    setApplyForReset(false)
  }

  return (
    <ConfigurationHistoriesWrapper>
      {!!hearingEvaluationHistoryList.length &&
        hearingEvaluationHistoryList.map((hearingEvaluation, index) => (
          <HistoryConfigItem
            key={index}
            active={
              (!previewIndex && !isShowingRevert && hearingEvaluation.active) ||
              previewIndex == index
            }
          >
            <DateWrapper
              onClick={() => {
                applyHEPreview(index)
              }}
            >
              {format(
                new Date(hearingEvaluation?.completeDate),
                "d LLL yyyy hh:mm aaa"
              )}
              {hearingEvaluation.manuallyCreated && (
                <ManualWrapper>
                  <ManualIcon />
                </ManualWrapper>
              )}
            </DateWrapper>

            <StatusWrapper>
              {showPending(hearingEvaluation.id) && (
                <LabelWrapper>Pending</LabelWrapper>
              )}

              {showSelected(hearingEvaluation, index) && (
                <BigCircle>
                  <SmallCircle
                    onClick={() => {
                      resetTempIndex()
                    }}
                  />
                </BigCircle>
              )}

              {showEnabled(hearingEvaluation.active) && [
                <LabelWrapper>Enabled</LabelWrapper>,
                <CheckCircle>
                  <CheckIcon viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12" />
                  </CheckIcon>
                </CheckCircle>,
              ]}

              {showEmptyCircle(hearingEvaluation, index) && (
                <ControlButtons>
                  <EmptyCircle
                    id={`history-configuration-${index}`}
                    onClick={() => {
                      applyConfiguration(index)
                    }}
                  />
                </ControlButtons>
              )}
            </StatusWrapper>
          </HistoryConfigItem>
        ))}

      {!showHearingAssessmentModal && (
        <HistoryConfigItem>
          <DateWrapper active={isShowingRevert}>
            {" "}
            Revert to Factory Presets
          </DateWrapper>

          <StatusWrapper>
            {lastLogWithStatus &&
              lastLogWithStatus?.payload?.hearingAssessment == null && (
                <LabelWrapper>Pending</LabelWrapper>
              )}

            {applyForReset && (
              <BigCircle>
                <SmallCircle
                  onClick={() => {
                    resetTempIndex()
                  }}
                />
              </BigCircle>
            )}

            {!applyForReset &&
              !(
                lastLogWithStatus &&
                lastLogWithStatus?.payload.hearingAssessment == null
              ) && (
                <ControlButtons>
                  <EmptyCircle
                    id={`history-configuration-reset`}
                    onClick={() => {
                      applyConfiguration("reset")
                    }}
                  />
                </ControlButtons>
              )}
          </StatusWrapper>
        </HistoryConfigItem>
      )}
    </ConfigurationHistoriesWrapper>
  )
}

export default observer(HearingEvaluationHistory)
